import {
  FetchMobileSettingsRequest,
  FetchMobileSettingsSuccess,
  FetchMobileSettingsFailure,
  UpdateMobileSettingsRequest,
  UpdateMobileSettingsSuccess,
  UpdateMobileSettingsFailure,
} from './mobile-settings.actions'
import { MobileSettingsService } from './mobile-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as MobileSettingsTypes from './mobile-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class MobileSettingsEffects {
  constructor(
    private actions: Actions,
    private mobileSettingsService: MobileSettingsService,
  ) {}

  FetchMobileSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(MobileSettingsTypes.FETCH_MOBILE_SETTINGS_REQUEST),
      switchMap((action: FetchMobileSettingsRequest) => {
        return this.mobileSettingsService.fetchMobileSettings().pipe(
          map((result) => {
            return new FetchMobileSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchMobileSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateMobileSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_REQUEST),
      switchMap((action: UpdateMobileSettingsRequest) => {
        return this.mobileSettingsService
          .updateMobileSettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdateMobileSettingsSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateMobileSettingsFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
